import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {setOutboxEmailOpened, setOutboxSubModule, setSeenOutboxEmail, taskCreatorModalToggle} from 'state/actions'
import DetailedEmail from './detailedEmail'
import OutboxEmailList from './outboxEmailList'
import TaskCreator from '../taskCreator'
import styles from './outbox.scss'
import i18n from 'lib/i18n'
import cs from 'classnames'
import OutboxPdfSync from './outboxPdfSync'

const _ = i18n('outbox')

@connect(
	({
        outbox: {items, modalIsOpen, opened, subModule},
        app: {security}, inbox: { staff }
    }) => ({items, modalIsOpen, opened, subModule, security, staff}),
    {setOutboxEmailOpened, setOutboxSubModule, setSeenOutboxEmail, taskCreatorModalToggle}
)
export default class Outbox extends Component {
	static propTypes = {
		items: PropTypes.arrayOf(PropTypes.object),
		modalIsOpen: PropTypes.bool,
        opened: PropTypes.string,
        setOutboxEmailOpened: PropTypes.func.isRequired,
        setOutboxSubModule: PropTypes.func.isRequired,
        setSeenOutboxEmail: PropTypes.func.isRequired,
        subModule: PropTypes.string,
    }

    constructor(props) {
        super(props)
        this.state = {outboxSyncIsOpen: false}
    }

    /**
     * This function naviget to the detailed overview of a sent email and set seen that email.
     */
    zoomTo = email => {
        const {setOutboxEmailOpened, setOutboxSubModule, setSeenOutboxEmail} = this.props
        if (!email.seenInOutbox) {
            setSeenOutboxEmail(email.id)
        }
		setOutboxEmailOpened(email.id)
		setOutboxSubModule('detailedEmail')
    }

    /**
     * This function will close the detailed page of an email.
     */
    zoomOut = () => {
		const {setOutboxEmailOpened, setOutboxSubModule} = this.props
        setOutboxEmailOpened()
        setOutboxSubModule()
    }

    /**
     * Retrieves the 'Inboxtask' permission value from security
     * if the permission was not found in the security state value, the value will be false
     * @return {bool} the 'Inboxtask' permission value
     */
    getTaskCreatorSecurity = () => {
        const { security } = this.props
		let securityValue = false

		if(security.actions && security.actions.length) {
			security.actions.map((value,key) => {
				if(value.actionName === 'Inboxtask') {
                    if(typeof value.actionAllowed === 'string') {
                        if(value.actionAllowed === 'true') {
                            securityValue = true
                        }
                    } else {
                        securityValue = value.actionAllowed
                    }
				}
			})
        }

		return securityValue;
    }

    /**
     * Handles the the taskCreator modal visibility toggeling
     */
    handleTaskCreatorModalToggling = () => {
        const { taskCreatorModalToggle } = this.props
        taskCreatorModalToggle()
    }

    /**
     * Converts the outbox items to task `shape` objects to be readable by the taskCreator component
     * @param {array} items the list of data to be converted
     * @return {array} the task `shape` objects generated data
     */
    generateTaskCreatorItems = ( items ) => {
        let convertedItems = []
        let selectedItems = items.filter(item => item.checked)

        if( selectedItems.length > 0 ) {
            selectedItems.map((value, key) => {
                let ticketContent = value.content
                ticketContent += `<div style="border-bottom: 1px solid rgba(0,0,0,0.1); margin: 10px 0px;"></div>`

                ticketContent += `<p>${_('sentDate')}: ${value.sentDate}</p>`
                ticketContent += `<p>${_('fromEmailAddress')}: ${value.senderEmail}</p>`

                if( value.toEmailAddress && value.toEmailAddress.length > 0) {

                    let emailList = "";

                    value.toEmailAddress.map((emailAddress, key) => {
                        (key === 0 ) ? emailList += emailAddress : emailList += `,${emailAddress}`
                    })

                    ticketContent += `<p>${_('toEmailAddress')}: ${emailList}</p>`
                }

                convertedItems.push({
                    title: value.subject,
                    description: ticketContent,
                    endDate: value.sentDate,
                    taskRelation: value._id
                })
            })
        }

        return convertedItems
    }

    /**
     * This function helps to use an icon on a safe way
     */
    getIcon = () => {
        try {
            return require(`resources/images/autorenew.svg`)
        }catch(err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    render() {
        const {items, opened, staff} = this.props
        const {outboxSyncIsOpen} = this.state
        const openedEmailInstance = opened && items && items.length > 0 && items.filter((item,key)=>item.id==opened)[0] || {}
        return (
            <div id={`${styles.outboxModule}`}>
                <div className={styles.mainTitleDiv}>
                    <div className={`${styles.mainTitleContainer}`}>
                        <h2 className={`${styles.mainTitle}`}>
                            {_('title')}
                        </h2>
                        <h3>{_('subtitle')}</h3>
                    </div>
                    <div className={styles.moduleControls}>
                        <button onClick={this.zoomOut}
                            className={`${styles.backToList} ${styles.greyButton} ${opened ? 'visible' : styles.hidden}`}>
                            {_('backToList')}
                        </button>
                    </div>
                    {(openedEmailInstance.status == 'failed' || openedEmailInstance.status == 'bounced') &&
                    <div className={styles.moduleControls}>
                        <div onClick={()=>{this.setState({outboxSyncIsOpen: true})}}
                            className={cs(`${styles.backToList} ${styles.greyButton} ${opened ? 'visible' : styles.hidden}`, styles.regenerateButton)}>
                            <img className={styles.regenerateButtonIcon} src={this.getIcon()}/>
                            <div>{_('syncPDF')}</div>
                        </div>
                    </div>}
                </div>
                <OutboxEmailList
                    emails={items}
                    zoomTo={this.zoomTo}
                    taskConvertionSecurity={this.getTaskCreatorSecurity()}
                    handleMakeAsTodo={this.handleTaskCreatorModalToggling}
                />
                {opened && <DetailedEmail email={openedEmailInstance}/>}

                <TaskCreator
                    modalTitle={'outboxTaskCreatorModalTitle'}
                    taskItems={this.generateTaskCreatorItems(items)}
                    staffItems={staff}
                    convertionType="outbox"
                />
                {outboxSyncIsOpen &&
                    <OutboxPdfSync
                        email={openedEmailInstance}
                        callBack={() => {
                            this.setState({outboxSyncIsOpen: false})
                        }}
                    />
                }
		    </div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/outbox/index.jsx